import React, { FC, useEffect, useState } from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import {
  useReportValuesDispatchContext,
  useReportValuesStateContext
} from 'providers/ReportValues';

import { StyledSelectItem } from './styled';

interface IProps {
  label: string;
  value: string;
}

const SelectItem: FC<IProps> = ({ label, value }) => {
  const [selected, setSelected] = useState(false);
  const values = useReportValuesStateContext();
  const { setValues } = useReportValuesDispatchContext();

  const handleChangeIcd = (value: { title: string; id: string }) => {
    setValues({ ...values, icd: [...values.icd, value] });
  };

  const removeIcd = (value: string) => {
    setValues({ ...values, icd: values.icd.filter(item => item.id !== value) });
  };

  useEffect(() => {
    setSelected(!!values.icd.find(item => item.id === value));
  }, [value, values.icd]);

  return (
    <StyledSelectItem
      $selected={selected}
      justify="space-between"
      onClick={() => {
        const item = {
          title: label,
          id: value
        };

        if (selected) {
          removeIcd(value);
        } else {
          handleChangeIcd(item);
        }
      }}
    >
      <Typography.Text className="label-item">{label}</Typography.Text>
      {selected && <CheckOutlined />}
    </StyledSelectItem>
  );
};

export default SelectItem;
